import { z } from "zod";

const optionalTrimmed = z.preprocess(
  (value) => (typeof value === "string" && value.trim() === "" ? undefined : value),
  z.string().trim().optional(),
);

const apiBaseUrlSchema = z.string().trim().min(1).refine(
  (value) => value.startsWith("/") || /^https:\/\//u.test(value),
  "API adresi / ile başlamalı veya HTTPS kullanmalıdır.",
);

const envSchema = z.object({
  apiBaseUrl: apiBaseUrlSchema,
  useMockApi: z.boolean(),
  mockRole: z.enum(["customer", "admin", "anonymous"]),
  shopifyStorefrontUrl: z.string().url(),
  /** Abonelik ürününün mağazadaki yolu; oturumu düşen müşteriyi geri göndermek için. */
  subscriptionProductPath: z.string().trim().startsWith("/"),
  firebaseApiKey: optionalTrimmed,
  firebaseAuthDomain: optionalTrimmed,
  firebaseProjectId: optionalTrimmed,
  firebaseStorageBucket: optionalTrimmed,
  firebaseMessagingSenderId: optionalTrimmed,
  firebaseAppId: optionalTrimmed,
  recaptchaEnterpriseSiteKey: optionalTrimmed,
});

const parsed = envSchema.parse({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "/api",
  useMockApi: import.meta.env.VITE_USE_MOCK_API === "true",
  mockRole: import.meta.env.VITE_MOCK_ROLE ?? "customer",
  shopifyStorefrontUrl:
    import.meta.env.VITE_SHOPIFY_STOREFRONT_URL ?? "https://www.tropikalakdeniz.com",
  subscriptionProductPath:
    import.meta.env.VITE_SUBSCRIPTION_PRODUCT_PATH ?? "/products/abonelik-kutusu",
  firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  firebaseProjectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  firebaseStorageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  firebaseMessagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  firebaseAppId: import.meta.env.VITE_FIREBASE_APP_ID,
  recaptchaEnterpriseSiteKey: import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY,
});

if (parsed.useMockApi && import.meta.env.PROD) {
  throw new Error("Mock API production ortamında kullanılamaz.");
}

export const env = Object.freeze(parsed);

export function assertFirebaseEnvironment(): void {
  const required = [
    ["VITE_FIREBASE_API_KEY", env.firebaseApiKey],
    ["VITE_FIREBASE_AUTH_DOMAIN", env.firebaseAuthDomain],
    ["VITE_FIREBASE_PROJECT_ID", env.firebaseProjectId],
    ["VITE_FIREBASE_APP_ID", env.firebaseAppId],
    ["VITE_RECAPTCHA_ENTERPRISE_SITE_KEY", env.recaptchaEnterpriseSiteKey],
  ] as const;

  const missing = required.filter(([, value]) => !value).map(([name]) => name);
  if (missing.length > 0) {
    throw new Error(`Eksik portal yapılandırması: ${missing.join(", ")}`);
  }
}
